import {  Key, useState } from 'react';
import { Theme, makeStyles, styled } from '@material-ui/core';
import { ColumnItem, CustomCellEnum, DataItem } from '../nkCustomTable.types';
import { useTableContext } from '../nkCustomTable.context';
import { colors } from '../../../infrastructure/newDesignTheme';
import {_NkInput} from '../../nkInput/index';
import NkSelect from '../../nkSelect/index';

interface TableNkCellProps {
  data: DataItem;
  column: ColumnItem;
}
interface TableNkCustomCellProps extends TableNkCellProps {
  handleEditState: () => void;
}
interface StyledTdProps {
  $isOnEdit?: boolean;
}

const NkCustomInputCell = (data: DataItem, column: ColumnItem, onChange: (value: string | number) => void) => {
  const [value, setValue] = useState(data[column.key]);
  const localClasses = useStyles(); 

  return <_NkInput
    autoFocus={true}
    className={localClasses.customCell}
    name={column.key}
    value={value}
    propName={column.key}
    onChange={e => setValue(e.target.value)}
    onBlur={e => onChange(e.target.value)}
    {...column?.props}
  />
};

const NkCustomSelectCell = (data: DataItem, column: ColumnItem, onChange: (value: string | number) => void) => {
  const [value, setValue] = useState(data[column.key]);

  return <NkSelect
    items={column.optionConfig?.options ? column.optionConfig?.options : []}
    itemPropName={column.key}
    itemTitlePropName={column.optionConfig?.displayKey}
    value={value}
    name={column.key}
    onChange={e => {setValue(e.target.value); onChange(e.target.value);}}
    {...column?.props}
  />
};

const customCellMap = new Map([
  [CustomCellEnum.Input, NkCustomInputCell],
  [CustomCellEnum.Option, NkCustomSelectCell],
]);

const NkCell = ({ data, column}: TableNkCellProps) => {
  if (!column.isEditable || column.dataType === CustomCellEnum.Element) {

    // fragment ensures valid React child was passed in the data
    return <StyledTd $isOnEdit={false}><>{data[column.key]}</></StyledTd>
  }

  const [isOnEdit, setIsOnEdit] = useState(false);
  const handleEditState = () => { setIsOnEdit(!isOnEdit); };

  if (isOnEdit) {
    return <NkCustomCell
      data={data} 
      column={column}
      handleEditState={handleEditState} />
  }

  return <StyledTd $isOnEdit={false} onClick={handleEditState}>
    { column.customCellValue ? column.customCellValue(data) : data[column.key] }
  </StyledTd>
};

const NkCustomCell = ({ data, column, handleEditState}: TableNkCustomCellProps) => {
  const CustomCell = customCellMap.get(column.dataType);
  const context = useTableContext();
  const onChange = (value: string | number) => {
    handleEditState();
    context?.handleCellChange({value, key: column.key, source: data}) 
  };

  return <StyledTd $isOnEdit={true}>
    { CustomCell && CustomCell(data, column, onChange) } 
  </StyledTd>
};

export default NkCell;

const StyledTd = styled('td')<Theme, StyledTdProps>(({ theme, $isOnEdit }) => ({
  padding: theme.spacing(2),
  backgroundColor: $isOnEdit ? colors.almostHuman : 'initial',
}));

const useStyles = makeStyles(() => ({
  customCell: {
    margin: '0px',
    padding: '0px',
    input: {
      padding: '0px',
    },
    '& .MuiInputBase-inputMarginDense': {
      padding: '0px',
    }
  }
}));
